export const CATEGORIES = [
  {
    key: 'write',
    label: 'Write',
    icon: '✍️',
    accentVar: '--color-accent-write',
    placeholder: 'A story, poem, lyric, or script opener. One sentence is enough. Go further if you want.',
  },
  {
    key: 'build',
    label: 'Build',
    icon: '🔧',
    accentVar: '--color-accent-build',
    placeholder: 'An invention, app idea, product, or business concept. One sentence is enough. Go further if you want.',
  },
  {
    key: 'entertain',
    label: 'Entertain',
    icon: '😂',
    accentVar: '--color-accent-entertain',
    placeholder: 'A joke, observation, or improv premise. One sentence is enough. Go further if you want.',
  },
  {
    key: 'question',
    label: 'Question',
    icon: '💭',
    accentVar: '--color-accent-question',
    placeholder: 'A "what if", philosophical dilemma, or thought experiment. One sentence is enough. Go further if you want.',
  },
];
